var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeadsetMono = function SvgIconHeadsetMono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.9 11.954a9.1 9.1 0 0 1 18.2-.08 1.5 1.5 0 1 1-1-.07 8.1 8.1 0 0 0-16.2.15v.568q.14-.054.29-.093l1.055-.283a1.5 1.5 0 0 1 1.837 1.06l1.128 4.21c.139.52.068 1.073-.199 1.539a2.01 2.01 0 0 1-1.226.946l-1.52.407c-.23.062-.462.08-.687.061.326.247.733.393 1.174.393h3.677a1 1 0 0 1 .87-.508h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-.86-.492H5.751A2.95 2.95 0 0 1 2.8 18.836l-.732-2.733A3 3 0 0 1 2.9 13.15zm2.603 1.158a.5.5 0 0 1 .613.354l1.128 4.21c.07.265.034.546-.1.782a1.01 1.01 0 0 1-.618.477l-1.52.407a1 1 0 0 1-1.225-.707l-.747-2.79a2 2 0 0 1 1.414-2.45z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeadsetMono;